module.exports = "/assets/dist/images/Daydream.png?2e727bd9e58e237e61bf3ede71b407bc";